import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Your message has been sent successfully! ✅");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-page py-5">
      <div className="container">
        <h2 className="fw-bold text-center main-color mb-3">Contact Us</h2>
        <p className="text-center text-muted mb-5">
          We'd love to hear from you! Fill out the form below and we’ll get back to you.
        </p>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white">
              {/* Name */}
              <div className="mb-3">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control py-2"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label">Your Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control py-2"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Message */}
              <div className="mb-3">
                <label className="form-label">Your Message</label>
                <textarea
                  name="message"
                  rows="5"
                  className="form-control py-2"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {/* Submit */}
              <button type="submit" className="btn btn-outline-custom py-2 w-100">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
